(function identifyModule(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  /**
   * @private
   * identify: a new session created by a new visitor.
   */
  function identify() {
    const isNewSession = sessionStorage.getItem('isNewSession');

    if (isNewSession != null) {
      return;
    }

    sessionStorage.setItem('isNewSession', 'true');

    const eventForSegment = {
      event: 'New Session',
      eventType: 'segmentEvent',
      isIdentifyEvent: true,
      isIdentifyOnly: true,
      isNeustarRequired: true
    };

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventForSegment }
    }));
  }

  document.body.addEventListener('identifySegmentEventNewSession', identify);
}(window));
